function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2615 -13380)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(665 104)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14065.98,25805.959v0l-4.086-4.084h-5.79v-5.791l-4.105-4.105,4.105-4.1v-5.77h5.771l4.106-4.107,4.1,4.107h5.79v5.783l4.087,4.086-4.087,4.086v5.811h-5.8l-4.086,4.084Zm.251-21.123c-.146,0-.306,0-.5.016a7.149,7.149,0,0,0-1.321.221,8.54,8.54,0,0,1-1.45,13.348,7.135,7.135,0,0,0,1.807.631,7.271,7.271,0,0,0,1.444.146c.167,0,.333-.006.524-.02a7.108,7.108,0,0,0,2.766-.758,7.224,7.224,0,0,0,2.183-1.7,7.117,7.117,0,0,0,1.755-5.207,6.994,6.994,0,0,0-.764-2.754,7.149,7.149,0,0,0-1.7-2.17,7.251,7.251,0,0,0-4.742-1.758Z",
  transform: "translate(-12098 -12498)",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(2615 13380)",
  fill: "none"
}));

function SvgIconMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoon);
export default __webpack_public_path__ + "static/media/icon-moon.6a41fa38.svg";
export { ForwardRef as ReactComponent };